document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-spoil-yourself]");
  if (!btn) return;

  e.preventDefault();

  const card =
    btn.closest("product-card") ||
    btn.closest(".product-card") ||
    btn.closest("[data-product-id]") ||
    btn.closest("li") ||
    document;

  // 1) BEST: submit the actual add-to-cart form inside this card (keeps theme functionality)
  const addForm = card.querySelector('form[action^="/cart/add"]');

  if (addForm) {
    // requestSubmit triggers native submit + theme listeners
    if (typeof addForm.requestSubmit === "function") {
      addForm.requestSubmit();
    } else {
      // fallback for older browsers
      const submitBtn = addForm.querySelector('[type="submit"]') || addForm.querySelector('button');
      if (submitBtn) submitBtn.click();
      else addForm.submit();
    }
    return;
  }

  
  // 2) Next best: trigger theme quick add / choose button (opens modal if needed)
  const quickAddTrigger =
    card.querySelector("[data-quick-add-button]") ||
    card.querySelector("quick-add-component button") ||
    card.querySelector("add-to-cart-component button") ||
    card.querySelector("button[name='add']");

  if (quickAddTrigger) {
    quickAddTrigger.click();
    return;
  }

  // 3) Fallback: go to product page
  const url = btn.getAttribute("data-product-url");
  if (url) window.location.href = url;
});

select.addEventListener('change', () => {
  hiddenInput.value =
    select.options[select.selectedIndex].dataset.variantId;
});


